import React from "react";
import "./landing.css";

// We keep this helper exported so pages can use it
export const SROnlyH1 = ({ children }) => (
  <h1 className="sr-only">{children}</h1>
);

export const RandomVideoChatBanner = () => (
  <div className="landing-banner">
    <strong>Random Video Chat</strong> — Match by interests, play quick trivia,
    and meet new people safely. Click “Find a Partner” to start.
  </div>
);

export const ChatrouletteAlternativeBanner = () => (
  <div className="landing-banner">
    <strong>Chatroulette Alternative</strong> — A modern, bot-free way to talk to strangers.
    No outdated plugins, just fast, safe video chat with games.
  </div>
);

export const EmeraldChatAlternativeBanner = () => (
  <div className="landing-banner">
    <strong>Emerald Chat Alternative</strong> — 100% Free video chat. No premium tiers, no crashing, just real people and fun games.
  </div>
);
export const AzarAlternativeBanner = () => (
  <div className="landing-banner">
    <strong>Azar Alternative</strong> — No app download required. 100% Free video chat, no gems, and fun built-in games.
  </div>
);
export const CooMeetAlternativeBanner = () => (
  <div className="landing-banner">
    <strong>CooMeet Alternative</strong> — 100% Free video chat. No coins, no paywalls, just real people and fun games.
  </div>
);

export const OmegleAlternativeBanner = () => (
  <div className="landing-banner">
    <strong>Omegle Alternative</strong> — A modern, safer place to talk to strangers.
    No ads, quick guest login, and games to break the ice.
  </div>
);

export const MeetStrangersBanner = () => (
  <div className="landing-banner">
    <strong>Meet Strangers Online</strong> — Interest matching + fun challenges.
    Hit “Find a Partner” to connect now.
  </div>
);

export const VideoChatWithStrangersBanner = () => (
  <div className="landing-banner">
    <strong>Video Chat with Strangers</strong> — Fast matching with safety tools
    and zero recordings.
  </div>
);

export const FreeOnlineVideoChatBanner = () => (
  <div className="landing-banner">
    <strong>Free Online Video Chat</strong> — Ad-free, guest login, and games to
    keep conversations flowing.
  </div>
);
export const TriviaVideoChatBanner = () => (
  <div className="landing-banner">
    <strong>Trivia Video Chat</strong> — Play live trivia with strangers. Break the ice instantly and see who is smarter.
  </div>
);
export const LaughChallengeBanner = () => (
  <div className="landing-banner">
    <strong>Try Not To Laugh</strong> — The ultimate video chat challenge. Face off against strangers and see who cracks a smile first!
  </div>
);
export const TicTacToeVideoChatBanner = () => (
  <div className="landing-banner">
    <strong>Tic-Tac-Toe Video Chat</strong> — Challenge strangers to a classic game of X's and O's while you chat. No more boring silences!
  </div>
);

export const Connect4VideoChatBanner = () => (
  <div className="landing-banner">
    <strong>Connect 4 Video Chat</strong> — Challenge strangers to a classic 4-in-a-row match while you chat. The ultimate test of strategy on random video chat!
  </div>
);

export const AdFreeChatBanner = () => (
  <div className="landing-banner">
    <strong>Ad-Free Video Chat</strong> — No popups, no interruptions. Just 100% free, clean video chat with strangers.
  </div>
);
export const NoLoginChatBanner = () => (
  <div className="landing-banner">
    <strong>Random Chat No Login</strong> — Jump straight into the action. No forms, no emails, just instant video connections.
  </div>
);